module.exports = __webpack_public_path__ + "static/img/logotwo.a1779372.svg";